<div class="container-fluid">
    <div class="card border-0 mt-3 mb-3 rounded-4 shadow bg-white p-3">
        <!-- heading -->
        <div class="card text-center border-0 rounded-4 d-flex justify-content-center align-items-center p-2"
            style="background-color: #3498db;">
            <p class=" mx-1 p-1 fs-2 mb-3 mt-3 text-light text-wrap" style="font-weight: bold; ">
                Consolidated Report
            </p>
            <p class="text-light text-wrap">Monitor and analyze Consolidated reports with ease.</p>
        </div>

        <!-- dropdown form form -->
        <form #dropdownForm="ngForm" class="mt-4 mx-2">
            <!-- dropdowns -->

            <div class="row g-1 justify-content-between bg-success border-0 rounded-4 p-3 filter-selection">
                <div class="col col-lg-6 col-sm-12  text-center">

                    <!--select country -->
                 <div class="card w-100 border-0 rounded-3 dropdown-card">
                    <div class="d-flex justify-content-start align-items-center">
                            
                        <div class="mx-1 px-2">
                            <label for="country" class="fw-medium">Select Country:</label>
                        </div>
                        <div class="card-body mx-2 p-3">
                            <select name="country" id="country" (change)="onSelected()" [(ngModel)]="selectedCountry"
                                required class="form-select" aria-label="Default select example" #country>
                                <option value="" selected>Select Country</option>
                                <option *ngFor="let esites of ecommarcebrands" [value]="esites.country">
                                    {{esites.country | uppercase}}
                                </option>
                            </select>
                        </div>

                    </div>
                  </div>  
                </div>
             
                <!--select platform -->
                <div class="col col-lg-6 col-sm-12 text-center">
                    <div class="card w-100 border-0 rounded-3 dropdown-card">
                        <div class="d-flex justify-content-start align-items-center">
                            
                            <div class="mx-1 px-2" >
                                <label for="platform" class="fw-medium">Select Platform:</label>
                            </div>

                            <div class="card-body mx-2 p-3" >
                                <select name="platform" (change)="onChange()" [(ngModel)]="selectedPlatform" required class="form-select "
                                    aria-label="Default select example" #platform>
                                    <option value="" selected>Select Platform</option>
                                    <option *ngFor="let platform of filteredSites" [value]="platform.name">
                                        {{platform.name}}
                                    </option>
                                </select>
                            </div>

                        </div>
                       
                    </div>
                </div>
            </div>

            <div [hidden]="true" class="card border-0 rounded-4 p-4 filter-selection">
                <!-- card row -->
                <div class="d-flex align-items-center justify-content-around card-container mx-1 p-2">
                    <!-- //country card -->
                    <div class="card border-0 rounded-3 dropdown-card">
                        <div class="d-flex justify-content-start align-items-center">
                            
                            <div class="mx-1 px-2">
                                <label for="country" class="fw-medium">Select Country:</label>
                            </div>
                            <div class="card-body mx-2 p-3">
                                <select name="country" id="country" (change)="onSelected()" [(ngModel)]="selectedCountry"
                                    required class="form-select" aria-label="Default select example" #country>
                                    <option value="" selected>Select Country</option>
                                    <option *ngFor="let esites of ecommarcebrands" [value]="esites.country">
                                        {{esites.country | uppercase}}
                                    </option>
                                </select>
                            </div>

                        </div>
                       
                    </div>
                    <!-- //platform card -->
                    <div class="card border-0 rounded-3 dropdown-card">
                        <div class="d-flex justify-content-start align-items-center">
                            
                            <div class="mx-1 px-2" >
                                <label for="platform" class="fw-medium">Select Platform:</label>
                            </div>

                            <div class="card-body mx-2 p-3" >
                                <select name="platform" (change)="onChange()" [(ngModel)]="selectedPlatform" required class="form-select "
                                    aria-label="Default select example" #platform>
                                    <option value="" selected>Select Platform</option>
                                    <option *ngFor="let platform of filteredSites" [value]="platform.name">
                                        {{platform.name}}
                                    </option>
                                </select>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </form>

        <div class="card border-0 rounded-3 mt-3" [ngClass]="searchResponse?'opacity-100':'opacity-50'">
            <div class="row row-cols-md-3">
                <div class="col p-4">
                    <div class="card border-0 shadow bg-white p-4">
                        <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                            <p class="fs-5">Product Search</p>
                            <p class="fs-5">{{searchResponse?.searchData?.productSearchCount||0}}</p>
                            <button class="btn  text-light" style="background-color: #3498db;" (click)="productHistory()"  >View History</button>
                        </div>
                    </div>
                </div>
                <div class="col p-4">
                    <div class="card border-0 shadow bg-white p-4">
                        <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                            <p class="fs-5">Keyword Search</p>
                            <p class="fs-5">{{searchResponse?.searchData?.keywordQueryCount||0}}</p>
                            <button class="btn  text-light" style="background-color: #3498db;" (click)="keywordHistory()">View History</button>
                        </div>
                    </div>
                </div>
                <div class="col p-4">
                    <div class="card border-0 shadow bg-white p-4">
                        <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                            <p class="fs-5">Market Search</p>
                            <p class="fs-5">{{searchResponse?.searchData?.marketSearchCount||0}}</p>
                            <button class="btn  text-light" style="background-color: #3498db;" (click)="marketHistory()">View History</button>
                        </div>
                    </div>
                </div>
                <div class="col p-4">
                    <div class="card border-0 shadow bg-white p-4">
                        <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                            <p class="fs-5">Distributor Search</p>
                            <p class="fs-5">{{searchResponse?.searchData?.distributorSearchCount||0}}</p>
                            <button class="btn  text-light" style="background-color: #3498db;" (click)="distributorHistory()">View History</button>
                        </div>
                    </div>
                </div>
                <div class="col p-4">
                    <div class="card border-0 shadow bg-white p-4">
                        <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                            <p class="fs-5">Competitive Stratergy</p>
                            <p class="fs-5">{{searchResponse?.searchData?.competitiveStratergyCount|| 0}}</p>
                            <button class="btn  text-light" style="background-color: #3498db;" (click)="competitveHistory()">View History</button>
                        </div>
                    </div>
                </div>
                <div class="col p-4">
                    <div class="card border-0 shadow bg-white p-4">
                        <div class="card-body d-flex flex-column justify-content-center align-items-center text-center">
                            <p class="fs-5">Competitior Analysis</p>
                            <p class="fs-5">{{searchResponse?.searchData?.competitiorsAnalysisCount || 0}}</p>
                            <button class="btn  text-light" style="background-color: #3498db;" (click)="CompetitiorHistory()">View History</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="mx-3">

        <div class="d-flex justify-content-center align-items-center">
              <div class="text-center">
                <p class="bottom-a"> © 2024 MarketScopePro </p>
                <p class="bottom-a"> Powered by DataXplode </p>
              </div>
        </div>

    </div>
</div>